import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Book, Ship, Anchor, TrendingUp } from 'lucide-react';

const guideCategories = [
  {
    title: 'Getting Started',
    icon: Book,
    items: [
      { path: '/guides/essentials', label: 'Yacht Essentials' },
    ],
  },
  {
    title: 'Yacht Types',
    icon: Ship,
    items: [
      { path: '/guides/types-propulsion', label: 'Types by Propulsion' },
      { path: '/guides/types-purpose', label: 'Types by Purpose' },
      { path: '/guides/hull-design', label: 'Hull & Design' },
    ],
  },
  {
    title: 'Ownership',
    icon: Anchor,
    items: [
      { path: '/guides/buying-ownership', label: 'Buying & Ownership' },
      { path: '/guides/maintenance-safety', label: 'Maintenance & Safety' },
    ],
  },
  {
    title: 'Industry Insights',
    icon: TrendingUp,
    items: [
      { path: '/guides/trends-facts', label: 'Trends & Facts' },
    ],
  },
];

export default function GuideSidebar() {
  const location = useLocation();

  return (
    <div className="glass-light p-6 sticky top-32 max-h-[calc(100vh-180px)] overflow-y-auto">
      <h3 className="text-xl font-semibold mb-6 text-gold" style={{ fontFamily: 'Playfair Display, serif' }}>
        Knowledge Hub
      </h3>

      <div className="space-y-6">
        {guideCategories.map((category, idx) => {
          const Icon = category.icon;
          return (
            <div key={idx}>
              <div className="flex items-center gap-2 mb-3">
                <Icon size={16} className="text-gold" />
                <h4 className="text-sm uppercase tracking-wide text-white/60 font-semibold">{category.title}</h4>
              </div>
              <div className="space-y-1 ml-6">
                {category.items.map((item, itemIdx) => {
                  const isActive = location.pathname === item.path;
                  return (
                    <Link
                      key={itemIdx}
                      to={item.path}
                      className={`flex items-center gap-2 py-2 px-3 rounded-none text-sm transition-colors ${
                        isActive
                          ? 'bg-gold/20 text-gold border-l-2 border-gold'
                          : 'text-white/70 hover:text-gold hover:bg-white/5'
                      }`}
                      data-testid={`guide-nav-${item.path.split('/').pop()}`}
                    >
                      <ChevronRight size={14} />
                      <span>{item.label}</span>
                    </Link>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
